import { graphql } from 'gql/generated'

export const ROUTING_PROJECT_PLAN_FRAGMENT_NAME = 'RoutingProjectPlan'
export const ROUTING_PROJECT_PLAN_FRAGMENT = graphql(`
  fragment RoutingProjectPlan on RoutingProjectPlan {
    id
    name
    status
    dataset {
      name
      emptyDow
      locations {
        id
        label
        coordinates {
          latitude
          longitude
        }
        dow
      }
    }
    constraints {
      origin {
        id
        label
      }
      destination {
        id
        label
      }
      vehicles {
        number
        capacity
      }
      maxStops
      maxDuration
      maxDistance
      stopDuration
      startTime
      endTime
    }
    optimizations {
      id
      dow
      routes {
        id
        name
        isLocked
        polyline
        distance
        duration
        costs {
          minCost
          maxCost
        }
        stops {
          arrival {
            day
            time
          }
          departure {
            day
            time
          }
          location {
            id
            label
            coordinates {
              latitude
              longitude
            }
            dow
          }
        }
      }
      skippedLocations {
        reasons
        location {
          id
          label
          coordinates {
            latitude
            longitude
          }
          dow
        }
      }
    }
  }
`)

export const ROUTING_PROJECT_DATASET_FRAGMENT_NAME = 'RoutingProjectDataset'

export const ROUTING_PROJECT_DATASET_FRAGMENT = graphql(`
  fragment RoutingProjectDataset on RoutingProjectDataset {
    id
    name
    emptyDow
    locations {
      id
      label
      coordinates {
        latitude
        longitude
      }
      dow
    }
  }
`)
export const ROUTING_PROJECT_FRAGMENT_NAME = 'RoutingProject'

export const ROUTING_PROJECT_FRAGMENT = graphql(`
  fragment RoutingProject on RoutingProject {
    id
    name
    tags
    plans {
      ...RoutingProjectPlan
    }
    datasets {
      ...RoutingProjectDataset
    }
  }
`)

export const GET_ROUTING_PROJECTS = graphql(`
  query routingProjects($input: RoutingProjectsInput!, $pagination: PaginationV2) {
    routingProjects(input: $input, pagination: $pagination) {
      items {
        id
        name
        tags
        plans {
          id
          name
        }
      }
      total
    }
  }
`)

export const GET_ROUTING_PROJECT = graphql(`
  query GetRoutingProject($input: RoutingProjectInput!) {
    routingProject(input: $input) {
      routingProject {
        id
        name
        plans {
          id
          name
        }
        datasets {
          id
          name
        }
      }
    }
  }
`)

export const GET_ROUTING_PROJECTS_TAGS = graphql(`
  query GetRoutingProjectsTags {
    routingProjectsTags {
      tags
    }
  }
`)

export const GET_ROUTING_PROJECT_PLAN = graphql(`
  query GetRoutingProjectPlan($input: RoutingProjectPlanInput!) {
    routingProjectPlan(input: $input) {
      plan {
        ...RoutingProjectPlan
      }
    }
  }
`)

export const GET_ROUTING_PROJECT_PLAN_EXPORT = graphql(`
  query GetRoutingProjectPlanExport($input: RoutingProjectPlanInput!) {
    routingProjectPlanExport(input: $input) {
      status
      url
    }
  }
`)
